module.exports = __webpack_public_path__ + "static/media/iStock-1176842849-1080-crop-1080x675.07913a0d.jpg";